<template>
  <slot :request-logout="userStore.requestLogout">
    <a @click="userStore.requestLogout">로그아웃</a>
  </slot>
</template>

<script setup lang="ts">
const userStore = $dy__useDYUserStore()
</script>